export default {
    methods: {
        resetObject() {
            this.data = JSON.parse(JSON.stringify(this.rawData));
            this.resetErrors();
        },
        prepareData(data) {
            return data;
        },
        prepareFormData(data) {
            return {
                insurance_fund: {
                    name: data.name,
                    number: data.number,
                    language: data.language,
                    address: data.address,
                    zip: data.zip,
                    city: data.city,
                    fax: data.fax,
                    phone: data.phone,
                    email: data.email,
                },
            };
        },
    },
};
